// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillExportPayloadAssignment\ApiBillExportPayloadAssignment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Bill, BillData, BillOptions } from 'data/models/Bill';
import { ExportPayload, ExportPayloadData, ExportPayloadOptions } from 'data/models/ExportPayload';

// BillExportPayloadAssignmentData is the class that BillExportPayloadAssignment serializes to/from
export interface BillExportPayloadAssignmentData {
    BillId : number;
    ExportPayloadId : number;
	
    Bill : BillData | null;
    ExportPayload : ExportPayloadData | null;
	
}

// BillExportPayloadAssignmentOptions is the class which may be passed to the BillExportPayloadAssignment constructor to define optional initial data values
export interface BillExportPayloadAssignmentOptions {
    BillId : number;
    ExportPayloadId : number;
	
    Bill? : BillOptions | null;
    ExportPayload? : ExportPayloadOptions | null;
	
}

export class BillExportPayloadAssignment {
    public BillId : DataSignal<number>;
    public ExportPayloadId : DataSignal<number>;
	
    public Bill : DataSignal<Bill | null>;
    public ExportPayload : DataSignal<ExportPayload | null>;
	

    constructor();
    constructor(data : BillExportPayloadAssignmentOptions);
    constructor(data: BillExportPayloadAssignmentOptions | null = null) {
        this.BillId = jsonableObservable(S.value<number>(data && data.BillId !== undefined ? data.BillId : 0));
        this.ExportPayloadId = jsonableObservable(S.value<number>(data && data.ExportPayloadId !== undefined ? data.ExportPayloadId : 0));
	    
        this.Bill = S.value<Bill | null>(null);
        this.ExportPayload = S.value<ExportPayload | null>(null);
	    
    }

    static key(obj : BillExportPayloadAssignment) {
        return obj.BillId() + '\u2618' + obj.ExportPayloadId();
    }
    
    static dataKey(obj : BillExportPayloadAssignmentOptions) {
        return obj.BillId + '\u2618' + obj.ExportPayloadId;
    }

    static update(obj : BillExportPayloadAssignment, data : BillExportPayloadAssignmentOptions) {
        S.freeze(() => {
            if (data.BillId !== undefined) obj.BillId(data.BillId);
            if (data.ExportPayloadId !== undefined) obj.ExportPayloadId(data.ExportPayloadId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BillExportPayloadAssignment.ts